<template>
    <div ref="tip" style="width: 96px">
        <div class="horizontal" style="justify-content: space-between;">
            <div v-for="(day, index) in list" :key="index">
                <div v-if="data.lastUpdate != undefined && data.lastUpdate=='0001-01-01T00:00:00'" class="the-thing" :style="'background-color: #AAAAAA; border-color: #7A7A7A; cursor: default;'"></div>
				        <div v-else-if="calculateAlarmOffDate(7-index, data)" class="the-thing" :style="'background-color: #f3f3f3; border-color: #e0e0e0; cursor: default;'"></div>
				        <div v-else-if="calculateDate(7-index, data)" class="the-thing" :style="'background-color: #AAAAAA; border-color: #7A7A7A; cursor: default;'"></div>
                <div v-else @click="(args) => openInfo(args, day, index)" class="the-thing" :style="'background-color: ' + ['#3CD6B1', '#FFBD6D', '#FF6666'][day] + '; border-color: ' + ['#3EAE94', '#C69C65', '#C65F60'][day]"></div>
            </div>
        </div>

        <div class="horizontal the-thing-title" style="justify-content: space-between;">
            <div>{{$t('7daysAgo')}}</div>
            <div>{{$t('Today')}}</div>
        </div>
    </div>
</template>

<script>
import Modal from '@/components/Modal'
import TooltipSystemStatus from '@/components/Systems/TooltipSystemStatus.vue';

export default {
    components: {
        Modal,
        TooltipSystemStatus
    },
    props: {
        callback: {

        },
    },
    data() {
        return {
            data: {},
            header: '',
            tooltip: false,
            list: []
        }
    },
    methods: {
        getData() {
            this.list = this.data[this.data.column.field].slice().reverse();

            if(this.data.column.field == 'visits') {
              let max = Math.max.apply(null, this.list);
              let green = 0.6*max;
              let yellow = 0.3*max;

              for(let i = 0; i < this.list.length; i++) {

                if(this.list[i] >= green) {
                  this.list[i] = 0;
                } else if(this.list[i] >= yellow) {
                  this.list[i] = 1;
                } else {
                  this.list[i] = 2;
                }
              }
            } else if(this.data.column.field == 'statusTab') {
                for(let i = 0; i < this.list.length; i++) {
                  this.list[i] = this.list[i][0];
              }
            }
        },
		calculateDate(index, data) {
        	let dt = new Date()
			    dt = new Date(dt.setDate(dt.getDate() - index))
          let ret = dt.setTime(dt.getTime() - 1 * 60 * 60 * 1000);
			    return ret > new Date(data.lastUpdate)
		},
        calculateAlarmOffDate(index, data) {
            let dt = new Date()
            dt = new Date(dt.setDate(dt.getDate() - index))

            return (data.alarmsOffCrfi != undefined && data.alarmsOffCrfi != '0001-01-01T00:00:00' && dt > new Date(data.alarmsOffCrfi))
              || (data.alarmsOffMonitoring != undefined && data.alarmsOffMonitoring != '0001-01-01T00:00:00' && dt > new Date(data.alarmsOffMonitoring));
        },
        openInfo(args, value, index){
            if(this.callback != undefined) {
                this.callback(this.data, 'INFO', 7 - index, value, args)
            }
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

// zielony: #3CD6B1; / #3EAE94
// czerwony: #FF6666; / #C65F60
// pomaranczowy: #FFBD6D; / #C69C65
// szary: #7A7A7A / #5C5C5C

<style scoped>
.the-thing {
    border: 1px solid #3EAE94;
    height: 16px;
    width: 8px;
    border-radius: 2px;
    background-color: #3CD6B1;
    cursor: pointer;
}

.the-thing-title {
    font-family: "SourceSansProBold", sans-serif;
    font-size: 8px;
    font-style: normal;
    font-weight: 600;
    color: #414F51;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/SystemStatus.vue